import * as React from "react"
import { MdAdd } from "react-icons/md"
import { useTracker } from "@modules/analytics"
import { EmptyStateGraphic } from "@modules/ui/components/EmptyStateGraphic"
import { EmptyState, EmptyStatePrimaryAction } from "gatsby-interface"
import { sites as text } from "@modules/locales/default.js"
import { recordCreateSite } from "@modules/fullStory"
import { getPathToCreateSite } from "@modules/site/create/shared/utils"
import { useOrganizationPermissionsFieldsFragment } from "@modules/organization/fragments.generated"

export type SitesEmptyStateProps = {
  organizationId: string
}

export function SitesEmptyState({ organizationId }: SitesEmptyStateProps) {
  const { trackButtonClicked } = useTracker()
  const { data } = useOrganizationPermissionsFieldsFragment(organizationId)
  const hasCreateSitesPermissions = data?.permissions?.sites?.create ?? false

  const createSitePath = getPathToCreateSite(organizationId)

  return (
    <EmptyState
      heading={
        hasCreateSitesPermissions
          ? text.headers.noSites
          : text.headers.noSitesViewer
      }
      headingAs="h2"
      text={
        hasCreateSitesPermissions
          ? text.messages.noSitesDescription
          : text.messages.noSitesDescriptionViewer
      }
      graphic={<EmptyStateGraphic />}
      variant="BORDERED"
      primaryAction={
        hasCreateSitesPermissions ? (
          <EmptyStatePrimaryAction
            to={createSitePath}
            onClick={() => {
              recordCreateSite()
              trackButtonClicked("Create new site", {})
            }}
            rightIcon={<MdAdd />}
            data-cy="create-site-button"
          >
            {text.actions.addSite}
          </EmptyStatePrimaryAction>
        ) : null
      }
    />
  )
}
